import React from "react";
import "./DataTable.css"; // Update the CSS file name and path accordingly

function DataTable({ data }) {
  const airports = [...new Set(data.map((item) => item["Αεροδρόμιο"]))];
  const years = [...new Set(data.map((item) => item["Έτος"]))];

  return (
    <div className="datatable-container">
      <div className="datatable-scrollable">
        <div className="datatable-wrapper">
          <table className="datatable-table">
            <thead>
              <tr>
                <th>Αεροδρόμιο</th>
                {years.map((year) => (
                  <th key={year}>{year}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {airports.map((airport) => (
                <tr key={airport}>
                  <td>{airport}</td>
                  {years.map((year) => {
                    const item = data.find(
                      (item) =>
                        item["Αεροδρόμιο"] === airport && item["Έτος"] === year
                    );
                    return (
                      <td key={year}>
                        {item ? item["Τεχνική Αποδοτικότητα"] : "-"}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default DataTable;
